import { Box, Button, Checkbox, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useState, useContext, useEffect } from 'react';
import { ColumnViewContext } from '../context';
import { checkChange, checkStatus, isNodeChecked, isNodeUnchecked } from '../service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getStyles } from './styles';

export function Column(props: ColumnProps) {
  const [expandedNode, setExpandedNode] = useState<BaseNode | undefined>();
  const [columnActiveNode, setColumnActiveNode] = useState<BaseNode | undefined>();
  const { root, setRoot, selections,  setSelections, activeNode, setActiveNode } = useContext(ColumnViewContext);
  const [selectedChild, setSelectedChild] = useState<string | undefined>();
  const theme = useTheme();
  const styles = getStyles(theme);

  useEffect(() => {
    if (props.nodes && props.selectedNode) {
      const pathKeys = props.selectedNode.split('|');
      let targetNode = props.selectedNode;
      let selectedChild;

      if (pathKeys.length) {
        targetNode = pathKeys[0];
        selectedChild = pathKeys.slice(1, pathKeys.length).join('|');
        if (props.parent) {
          targetNode = props.parent.value + '|' + targetNode;
        }
        setSelectedChild(selectedChild);
      }

      const selectedNode = props.nodes.find(item => item.value === targetNode);
      setExpandedNode(selectedNode);
    }
  }, [props.nodes, props.parent, props.selectedNode])
  
  useEffect(() => {
    if (expandedNode && activeNode && expandedNode.target === activeNode.target) {
      if (isNodeUnchecked(expandedNode) || !expandedNode.children || (expandedNode.children && !expandedNode.children.length)) {
        setActiveNode({ ...props.parent } as BaseNode);
        setColumnActiveNode(undefined);
        setExpandedNode(undefined);
      } else {
        setColumnActiveNode(expandedNode);
      }
    } else {
      setColumnActiveNode(undefined);
    }
  }, [ expandedNode, activeNode, setActiveNode, props.parent ]);
  
  function updateRoot(newRoot: NodeSet) {
    setRoot([...newRoot]);
  }

  function updateSelections(newSelections: Selections) {
    setSelections(new Set(newSelections));
  }

  const handleExpandCollapse = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, node: BaseNode | undefined) => {
    event.stopPropagation();

    if (expandedNode && node && expandedNode.target === node.target) {
      setExpandedNode(undefined);
      // props.parent && setActiveNode({ ...props.parent });
    } else {
      setExpandedNode(node);
    }
  }

  function handleCheckChange(node: BaseNode, status: boolean) {
    const [newRoot, newSelections] = checkChange(root, selections, node, status);
    updateRoot(newRoot);
    updateSelections(newSelections);
    if (props.onCheck) {
      props.onCheck([...newSelections]);
    }
  }

  async function handleNodeClick(node: BaseNode) {
    if (isNodeChecked(node)) {
      node.checked = checkStatus.unchecked;
      handleCheckChange(node, false);

    } else {
      node.checked = checkStatus.checked;
      setExpandedNode(node);
      handleCheckChange(node, true);
    }
    
    if (isNodeUnchecked(node) || !node.children || (node.children && !node.children.length)) {
      setActiveNode({ ...props.parent } as BaseNode);
      setExpandedNode(undefined);
    } else {
      setActiveNode({ ...node });
    }

    // loadNodeChildren(node);
  }

  return (
    props.nodes ?
    <React.Fragment>
      <tr>
        {
          props.nodes.map((node: any, index: number) => (
            <td 
              key={index} 
              onClick={() => handleNodeClick(node)}
            >
              <Box
                sx={[
                  styles.node,
                  (columnActiveNode && columnActiveNode.target === node.target)
                    ? styles.selected
                    : (node.target === expandedNode?.target ? styles.visited : false),
                ]}
              >
                <Typography component="span" sx={{ whiteSpace: 'nowrap', paddingRight: '1rem', minHeight: '100%', height: '100%', }}>
                  <Checkbox
                    checked={node.checked && node.checked[0] && node.checked[1]}
                    indeterminate={node.checked && node.checked[0] !== node.checked[1]}
                    size='small'
                    color="primary"
                    sx={{ padding: '4px' }}
                    onChange={() => handleNodeClick(node)}
                    onClick={event => event.stopPropagation()}
                  />
                  <Typography component="span">{node.label}</Typography>
                </Typography>
                {
                  node?.children && node.children.length ?
                  <Typography component="span" sx={{ minHeight: '100%', height: '100%', }} >
                    <Button sx={{ minWidth: '0px', width: '2em', minHeight: '100%', height: '100%', borderRadius: '8px', }} onClick={event => handleExpandCollapse(event, node)} >
                      <FontAwesomeIcon className="fas chevron-right fa-xs" icon="chevron-right" />
                    </Button>
                  </Typography>
                  : undefined
                }
              </Box>
            </td>
          ))
        }
      </tr>
      { (expandedNode && expandedNode.children) ? 
          <Column 
            key={expandedNode.target} 
            nodes={expandedNode.children} 
            getNodeChildren={props.getNodeChildren} 
            getRootNode={props.getRootNode} 
            onCheck={props.onCheck}
            parent={expandedNode}
            selectedNode={selectedChild}
          /> 
        : null 
      }
    </React.Fragment>
    : null
  )
}